// Reused enums
export enum ImageWithButtonsBlockStyles {
  HeroLarge = 'hero_large',
  HeroMedium = 'hero_medium',
  Callout = 'callout',
  CalloutColored = 'callout_colored',
}
